import ServiceCategoryPage from "../components/ServiceCategoryPage";
import refrigeratorRepairService from "../data/services/refrigeratorRepairService";

function RefrigeratorRepair() {
  return <ServiceCategoryPage service={refrigeratorRepairService} />;
}

export default RefrigeratorRepair;